import { ItemShownEvent } from '~/shared/event_subjects'
import GtmEmitter from './gtm_emitter'

import GtmEmitterState from './gtm_emitter_state'
import InPageGtmEmitterState from './in_page_gtm_emitter_state'
import TerminatedGtmEmitterState from './terminated_gtm_emitter_state'

// place が切り替わって最初に入る state
// pageData が設定されている
// page にはまだ enter していない
export default class PlaceEnteredGtmEmitterState extends GtmEmitterState {
  _itemShownEvent: ItemShownEvent

  constructor (itemShownEvent: ItemShownEvent) {
    super()
    this._itemShownEvent = itemShownEvent
  }

  onEnterState (context: GtmEmitter) {
    context.resetStoreData()
    context.commitStoreData()
    context.store.pageData = this._itemShownEvent
    context.forceEmitEvent('show_place')
  }

  onPlaceChanged (context: GtmEmitter, e: ItemShownEvent) {
    this._skimCurrentPage(context)
    context.changeState(new PlaceEnteredGtmEmitterState(e))
  }

  onEnterPage (context: GtmEmitter, pageData: {}) {
    this._skimCurrentPage(context)
    context.clearPageData()
    context.store.pageData = pageData
    context.changeState(new InPageGtmEmitterState())
  }

  onEvent (context: GtmEmitter, name: string, data: {} = {}) {
    context.changeState(new InPageGtmEmitterState({ name: name, data: data }))
  }

  terminate (context: GtmEmitter) {
    // 閲覧者がページを開いて、何もせずページを閉じる場合に閲覧イベントを飛ばす
    this._skimCurrentPage(context)
    context.changeState(new TerminatedGtmEmitterState())
  }

  _skimCurrentPage (context: GtmEmitter) {
    context.emitEventData({ event: 'page_enter', storeData: context.store })
    context.emitEventData({ event: 'page_leave', storeData: context.store })
  }
}
